export type PlatformStoreActivityLabelKey =
  | "ui.securityLogin"
  | "ui.securityLogout"
  | "ui.securityProfileUpdated"
  | "ui.securityPasswordChanged"
  | "ui.addStore"
  | "ui.editStore"
  | "ui.manageAssignments"
  | "ui.activityOrderUpload"
  | "ui.activityOrderEventUpload"
  | "ui.activityOrderPull"
  | "ui.activityOrderEventPull"
  | "ui.activityMenuSync"
  | "ui.activityStoreSync"
  | "ui.activitySettingsSync"
  | "ui.activityOperatorSync"
  | "ui.activityDeviceRegistered"
  | "ui.activityDeviceChanged"
  | "ui.activityStaffChanged"
  | "ui.activityMenuChanged"
  | "ui.activityStoreChanged"
  | "ui.activity";

/** Maps canonical audit event names to stable, localized UI message keys. */
export function platformStoreActivityLabelKey(eventType: string): PlatformStoreActivityLabelKey {
  if (eventType === "auth.login") return "ui.securityLogin";
  if (eventType === "auth.logout") return "ui.securityLogout";
  if (eventType === "account.profile.updated") return "ui.securityProfileUpdated";
  if (eventType === "account.password.changed") return "ui.securityPasswordChanged";
  if (eventType === "platform.store.created") return "ui.addStore";
  if (eventType === "platform.store.updated") return "ui.editStore";
  if (eventType === "platform.store.memberships.updated") return "ui.manageAssignments";
  if (/^sync\.order_upload\./.test(eventType)) return "ui.activityOrderUpload";
  if (/^sync\.order_event_upload\./.test(eventType)) return "ui.activityOrderEventUpload";
  if (/^sync\.order\.pull\./.test(eventType)) return "ui.activityOrderPull";
  if (/^sync\.order_event\.pull\./.test(eventType)) return "ui.activityOrderEventPull";
  if (/^sync\.config\.menu\./.test(eventType)) return "ui.activityMenuSync";
  if (/^sync\.config\.store\./.test(eventType)) return "ui.activityStoreSync";
  if (/^sync\.config\.settings\./.test(eventType)) return "ui.activitySettingsSync";
  if (/^sync\.config\.operators\./.test(eventType)) return "ui.activityOperatorSync";
  if (eventType === "device.bootstrap") return "ui.activityDeviceRegistered";
  if (/^admin\.device\./.test(eventType)) return "ui.activityDeviceChanged";
  if (/^admin\.user\./.test(eventType)) return "ui.activityStaffChanged";
  if (/^menu\.revision\./.test(eventType)) return "ui.activityMenuChanged";
  if (/^store\.(profile|settings)\.updated$/.test(eventType)) return "ui.activityStoreChanged";
  return "ui.activity";
}
